import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

//import avatar from "assets/img/faces/marc.jpg";
import isEmpty from '../../lib/isEmpty';

import {  getuserDetails,updateuser } from '../../actions/users';

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};

// toaster config
toast.configure();
let toasterOption = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}


const initialFormValue = {
  'name': "",
  'email': "",
  'phonenumber': "",
  'address1': "",
  'address2': "",
  'pincode': "",
  'city': "",
  'country': "",
  'Photofile' : "",

}

const useStyles = makeStyles(styles);

export default function UserProfile(props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [userdet, setUser] = useState();
  const [formValue, setFormValue] = useState(initialFormValue);
  const [validateError, setValidateError] = useState({});

  const { userId } = useParams();
   // console.log(userId,"asdfdsfdsfdsf");

  const handleFile = (event) => {
    const { id, files } = event.target;
    //settmpupimagefront(URL.createObjectURL(event.target.files[0]));

    let formData = { ...formValue, ...{ [id]: files[0] } }
    setFormValue(formData)
    //setValidateError(formData)
  };


  // function
  const onChange = (e) => {
    e.preventDefault();
   // console.log(e.target);
    const { id, value } = e.target;
    let formData = { ...formValue, ...{ [id]: value } }
    setFormValue(formData)
    // console.log(formValue);
    //setValidateError(formData)
  }

    const {
        name,
        email,
        phonenumber,
        address1,
        address2,
        pincode,
        city,
        country,
        Photofile,
    } = formValue

  const handleFormSubmit = async (e) => {
    //console.log("saran");
    e.preventDefault();
    console.log(formValue);

    let reqData = {
        name,
        email,
        phonenumber,
        address1,
        address2,
        pincode,
        city,
        country,
        Photofile,
        userId
    }
    console.log(reqData);
    let { error,message } = await updateuser(reqData);
    //console.log("error",error);
    toast.success(message, toasterOption);

    if (isEmpty(error)) {
      
      toast.success('User Updated', toasterOption);
    
       setTimeout(
        ()=> window.location.href='/Mudrattrqqqq/userlist'
        ,1000)
    } else {
      setValidateError(error);
    }
  }

  const getUserData = async () => {
    var test = await getuserDetails(userId);
    console.log("test",test)
    let formdata = {};
    if (test.userValue!=undefined) {
    formdata['name'] = test.userValue.name;
    formdata['email'] = test.userValue.email;
    formdata['phonenumber'] = test.userValue.phonenumber;
    formdata['address1'] = test.userValue.address1;
    formdata['address2'] = test.userValue.address2;
    formdata['pincode'] = test.userValue.pincode;
    formdata['city'] = test.userValue.city;
    formdata['country'] = test.userValue.country;
    setFormValue(formdata)
  }else{

    //setUser(test.userValue);
  }
  }

  useEffect(() => {
    getUserData();
  }, [])


  return (
    
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <form className={classes.form} noValidate onSubmit={handleFormSubmit}>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Edit User</h4>
                <p className={classes.cardCategoryWhite}>update the user</p>
              </CardHeader>
              <CardBody>
                <GridContainer>                 
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Name"
                      onChange={onChange}
                      id="name"
                      value={name}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                    {
                      
                        validateError.name && <span className="text-danger">{validateError.name}</span>
                    }
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Email address"
                      onChange={onChange}
                      value={email}
                      id="email"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                    {
                        validateError.email && <span className="text-danger">{validateError.email}</span>
                    }
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Mobile"
                      onChange={onChange}
                      value={phonenumber}
                      id="phonenumber"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                    {
                        validateError.phonenumber && <span className="text-danger">{validateError.phonenumber}</span>
                    }
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Address"
                      onChange={onChange}
                      id="address1"
                      value={address1}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                    {
                        validateError.address1 && <span className="text-danger">{validateError.address1}</span>
                    }
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="City"
                      onChange={onChange}
                      id="city"
                      value={city}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                    {
                        validateError.city && <span className="text-danger">{validateError.city}</span>
                    }
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="State"
                      onChange={onChange}
                      id="address2"
                      value={address2}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                    {
                        validateError.address2 && <span className="text-danger">{validateError.address2}</span>
                    }
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Country"
                      onChange={onChange}
                      id="country"
                      value={country}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                    {
                        validateError.country && <span className="text-danger">{validateError.country}</span>
                    }
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Pincode"
                      onChange={onChange}
                      id="pincode"
                      value={pincode}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                    {
                        validateError.pincode && <span className="text-danger">{validateError.pincode}</span>
                    }
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Profile image"
                      onChange={handleFile}
                      id="Photofile"
                      type="file"                      
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                     {
                      
                      validateError.photo && <span className="text-danger">{validateError.photo}</span>
                  }
                  </GridItem>                  
                </GridContainer>
              </CardBody>
              <CardFooter>
                <Button color="primary" type="submit">Update</Button>
              </CardFooter>
            </form>
          </Card>
        </GridItem>       
      </GridContainer>
    </div>
  );
}
